import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useStore from "../../features/store";
import ProfileList from "../../components/dashboard/profileList";
import Loading from "../../components/common/loading";
import DashboardLayout from "../../layout/dashboardLayout";

const DashboardProfiles = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const page = Number(searchParams.get("page")) || 1;
  const { profiles, isLoadingProfiles, fetchProfiles }: any = useStore();
  const pageSize = Math.ceil(profiles?.count / 10);

  useEffect(() => {
    fetchProfiles(page);
  }, [page]);

  const PaginationBtn = ({ number, isActive }: any) => (
    <button
      onClick={() => navigate(`/dashboard-profiles?page=${number}`)}
      className={`join-item btn btn-md shadow-none border-[1px] border-gray-100 hover:border-gray-100 hover:bg-gray-200 ${
        isActive ? "bg-gray-200" : "bg-white"
      }`}
    >
      {number}
    </button>
  );

  const getPaginationRange = () => {
    const totalPages = pageSize;
    const range = [];

    if (page > 1) range.push(1);
    if (page > 4) {
      range.push("...");
    }
    for (let i = Math.max(2, page - 2); i < page; i++) {
      range.push(i);
    }
    range.push(page);
    for (let i = page + 1; i <= Math.min(page + 2, totalPages - 1); i++) {
      range.push(i);
    }
    if (page < totalPages - 3) {
      range.push("...");
    }
    if (page < totalPages) {
      range.push(totalPages);
    }

    return range;
  };

  const paginationRange = getPaginationRange();

  return (
    <DashboardLayout>
      <div className="my-10">
        <div className="breadcrumbs text-sm">
          <ul>
            <li>
              <Link to="/dashboard">داشبورد</Link>
            </li>
            <li className="font-[900]"> کاربران بادی‌بان </li>
          </ul>
        </div>

        <h1 className="font-rokh font-[900] text-2xl my-6 text-center">
          کاربران بادی‌بان
        </h1>
        {isLoadingProfiles ? (
          <Loading />
        ) : (
          profiles && (
            <>
              <div className="rounded-xl overflow-hidden bg-white border-[1px] border-gray-100">
                <ProfileList data={profiles} />
              </div>
              <div className="join flex justify-center mt-10">
                {paginationRange.map((item, index) =>
                  item === "..." ? (
                    <span
                      key={index}
                      className="join-item btn btn-md shadow-none bg-transparent border-none"
                    >
                      ...
                    </span>
                  ) : (
                    <PaginationBtn
                      number={item}
                      isActive={Number(page) === item}
                      key={index}
                    />
                  )
                )}
              </div>
            </>
          )
        )}
      </div>
    </DashboardLayout>
  );
};

export default DashboardProfiles;
